/* global x5script */

class LoanCalculator {
  constructor() {
    this.selectors = {
      section: '.js-loan-calc',
      caclulator: '.js-loan-calc-form',
      calcInput: '.js-loan-calc-input',
      numericInput: '.js-numeric-input',
      rangeInput: '.js-range-input',
      rangeInputValue: '.js-range-input-value',
      summaryBoxLabel: '.js-loan-calc-summary-label',
      summaryBoxText: '.js-loan-calc-summary-text',
      summaryBoxValue: '.js-loan-calc-summary-value',
    };

    this.section = document.querySelector(this.selectors.section);

    if (!this.section) {
      return;
    }

    this.i18n = x5script.loanCalculator;

    this.classes = {
      active: 'is-active',
      rangeInput: 'js-range-input',
      invalid: 'is-invalid',
    };

    this.data = {
      formData: {},
      noUiSlider: null,
      sliders: {},
      isInit: false,
      summaryValueInitFontSize: null,
    };

    this.symbol = {
      dollar: '$',
      percent: '%',
    };

    this.calculate = {
      mortgage: this.calculateMortgage.bind(this),
      budget: this.calculateBudget.bind(this),
      refinance: this.calculateRefinance.bind(this),
    };

    this.formData = this.getFormData;
    this.formId = this.getFormId;

    this.DOM = {
      caclulators: this.section.querySelectorAll(this.selectors.caclulator),
      calcInputs: this.section.querySelectorAll(this.selectors.calcInput),
      numericInputs: this.section.querySelectorAll(this.selectors.numericInput),
      rangeInputs: this.section.querySelectorAll(this.selectors.rangeInput),
      summaryBoxValue: this.section.querySelector(
        this.selectors.summaryBoxValue,
      ),
    };

    import('nouislider').then(({ default: noUiSlider }) => {
      this.data.noUiSlider = noUiSlider;

      this.caclulatorsSubmitHandler();
      const initialActive = Array.from(this.DOM.caclulators).filter((calc) => {
        return calc.classList.contains(this.classes.active);
      });

      this.setActiveForm(initialActive[0]);

      this.initInputs();
      this.initRangeSlider();
      this.tabsChangeHadler();
      this.inputChangeHandler();

      this.submitForm();
    });
  }

  initInputs() {
    if (!this.DOM.numericInputs.length) {
      return;
    }

    this.DOM.numericInputs.forEach((input) => {
      const inputType = input.getAttribute('inputtype');

      input.addEventListener('input', (e) => {
        const self = e.target;
        const { value } = e.target;

        if (value.trim() === '') {
          return;
        }

        self.value = this.prepareInputValue(value, inputType);
      });

      const inputEvent = new Event('input');
      input.dispatchEvent(inputEvent);
    });
  }

  initRangeSlider() {
    if (!this.DOM.rangeInputs.length) {
      return;
    }

    this.DOM.rangeInputs.forEach((input) => {
      const slider = this.data.noUiSlider.create(input, {
        start: input.getAttribute('start'),
        step: parseInt(input.getAttribute('step'), 10),
        range: {
          min: parseInt(input.getAttribute('min'), 10),
          max: parseInt(input.getAttribute('max'), 10),
        },
        connect: 'lower',
        pips: {
          mode: 'positions',
          values: [0, 25, 50, 75, 100],
          density: 100,
          stepped: true,
        },
      });

      this.data.sliders[input.getAttribute('name')] = slider;

      slider.on('change', (values) => {
        const valueElement = input.parentElement.querySelector(
          this.selectors.rangeInputValue,
        );

        this.submitForm();

        if (valueElement) {
          const newValue = parseInt(values[0], 10);
          valueElement.innerText = `${newValue} ${valueElement.getAttribute(
            'data-label',
          )}`;
        }
      });
    });
  }

  tabsChangeHadler() {
    document.addEventListener('tab:changed', (e) => {
      const id = e.detail.activeTab;

      const activeForm = document
        .querySelector(id)
        .querySelector(this.selectors.caclulator);

      this.setActiveForm(activeForm);
      this.submitForm();

      const summaryLabel = this.section.querySelector(
        `${this.selectors.summaryBoxLabel}${id}-label`,
      );
      const summaryText = this.section.querySelector(
        `${this.selectors.summaryBoxText}${id}-text`,
      );

      if (summaryLabel.classList.contains(this.classes.active)) {
        return;
      }

      const summaryLabelActive = this.section.querySelector(
        `${this.selectors.summaryBoxLabel}.${this.classes.active}`,
      );
      const summaryTextActive = this.section.querySelector(
        `${this.selectors.summaryBoxText}.${this.classes.active}`,
      );

      if (summaryLabelActive) {
        summaryLabelActive.classList.remove(this.classes.active);
      }
      if (summaryTextActive) {
        summaryTextActive.classList.remove(this.classes.active);
      }

      if (summaryLabel) {
        summaryLabel.classList.add(this.classes.active);
      }

      if (summaryText) {
        summaryText.classList.add(this.classes.active);
      }
    });
  }

  caclulatorsSubmitHandler() {
    this.DOM.caclulators.forEach((calculator) => {
      this.DOM.form = calculator;
      const calcMethod = this.getFormId().replace('loan-calc-form-', '');

      this.DOM.form.addEventListener('submit', (e) => {
        e.preventDefault();
        return false;
      });

      this.DOM.form.addEventListener('calculate', (e) => {
        this.DOM.form = e.target;
        e.preventDefault();
        this.setFormData();
        let hasError = false;

        Array.from(Object.entries(this.getFormData())).forEach(
          ([name, value]) => {
            if (value.trim() === '') {
              this.DOM.form
                .querySelector(`input[name="${name}"]`)
                .classList.add(this.classes.invalid);

              hasError = true;
            }
          },
        );

        if (!hasError) {
          if (this.calculate[calcMethod]) {
            this.calculate[calcMethod]();
          }
        }
      });
    });
  }

  inputChangeHandler() {
    this.DOM.calcInputs.forEach((input) => {
      if (input.classList.contains(this.classes.rangeInput)) {
        return;
      }

      input.addEventListener('input', () => {
        clearTimeout(this.t);

        const { name } = input;

        if (name === 'mortgage-payment' || name === 'mortgage-percentage') {
          this.setFormData();
          const formData = this.getFormData();

          const payment = parseFloat(
            formData['mortgage-payment'].replace(/,/g, ''),
          );
          const percentage = parseFloat(formData['mortgage-percentage']);
          const price = parseFloat(
            formData['mortgage-price'].replace(/,/g, ''),
          );

          if (name === 'mortgage-payment') {
            const newValue = (100 * payment) / price;
            this.DOM.form.querySelector(
              'input[name="mortgage-percentage"]',
            ).value = this.prepareInputValue(
              Number.isNaN(newValue) ? 0 : newValue,
              'percent',
            );
          }

          if (name === 'mortgage-percentage') {
            const newValue = (price * percentage) / 100;
            this.DOM.form.querySelector(
              'input[name="mortgage-payment"]',
            ).value = this.prepareInputValue(
              Number.isNaN(newValue) ? 0 : newValue,
              'currency',
            );
          }
        }

        this.t = setTimeout(() => {
          this.submitForm();
        }, 500);
      });
    });
  }

  setActiveForm(form) {
    this.DOM.form = form;
  }

  setFormData() {
    const formId = this.getFormId();
    this.data.formData[formId] = {};

    this.DOM.form
      .querySelectorAll(this.selectors.calcInput)
      .forEach((input) => {
        const name = input.getAttribute('name');

        input.classList.remove(this.classes.invalid);

        if (input.classList.contains(this.classes.rangeInput)) {
          if (this.data.sliders[name]) {
            this.data.formData[formId][name] = this.data.sliders[name].get();
          }
        } else {
          this.data.formData[formId][name] = input.value.replace(/(\$|%)/, '');
        }
      });
  }

  getFormId() {
    return this.DOM.form.getAttribute('id');
  }

  getFormData() {
    return this.data.formData[this.getFormId()];
  }

  prepareInputValue(inputValue, inputType) {
    const value = `${inputValue}`;
    let preparedValue = value;
    let formattedValue = '';
    let prefix = '';
    let suffix = '';

    if (inputType === 'currency') {
      prefix = this.symbol.dollar;
      preparedValue = value.replace(/[^0-9]/g, '');
      formattedValue = LoanCalculator.formatNumber(preparedValue, 5, 0);
    } else if (inputType === 'percent') {
      suffix = this.symbol.percent;
      preparedValue = value
        .replace(/[^0-9.]/g, '')
        .replace(/,/g, '.')
        .replace(/[.](?!\d*$)/g, '');

      if (preparedValue > 100) {
        formattedValue = 100;
      } else if (preparedValue < 0) {
        formattedValue = 0;
      } else {
        formattedValue = preparedValue;
      }
    }

    return `${prefix}${formattedValue}${suffix}`;
  }

  submitForm() {
    this.DOM.form.dispatchEvent(new CustomEvent('calculate'));
  }

  static formatNumber(number, maxFractionDigits = 2, minFractionDigits = 0) {
    return new Intl.NumberFormat('en-US', {
      maximumFractionDigits: maxFractionDigits,
      minimumFractionDigits: minFractionDigits,
    }).format(number);
  }

  static formatResultNumber(number) {
    const minFractions = `${number}`.length > 4 ? 0 : 2;
    return `$${LoanCalculator.formatNumber(number, 2, minFractions)}`;
  }

  displayResult(resultText) {
    if (!this.data.isInit) {
      this.summaryValueInitFontSize = window.getComputedStyle(
        this.DOM.summaryBoxValue,
      ).fontSize;
      this.data.isInit = true;
    }

    this.DOM.summaryBoxValue.innerText = resultText;

    this.DOM.summaryBoxValue.style.fontSize = this.summaryValueInitFontSize;

    let diff =
      this.DOM.summaryBoxValue.parentElement.clientWidth -
      this.DOM.summaryBoxValue.clientWidth;

    while (diff < 0) {
      this.DOM.summaryBoxValue.style.fontSize = `${
        parseFloat(window.getComputedStyle(this.DOM.summaryBoxValue).fontSize) -
        5
      }px`;

      diff =
        this.DOM.summaryBoxValue.parentElement.clientWidth -
        this.DOM.summaryBoxValue.clientWidth;
    }
  }

  calculateMortgage() {
    const formData = this.formData();

    const price = parseFloat(formData['mortgage-price'].replace(/,/g, ''));
    const payment = parseFloat(formData['mortgage-payment'].replace(/,/g, ''));
    const rate = parseFloat(formData['mortgage-rate']);
    const term = parseFloat(formData['mortgage-term']);

    const i = rate / 100 / 12;
    const n = 12 * term;
    const p = price - payment;
    const mp = (1 + i) ** n;
    const formula = (p * (i * mp)) / (mp - 1);

    const result = Math.ceil(formula);
    let resultText = '';

    if (!Number.isNaN(result) && result >= 0) {
      resultText = LoanCalculator.formatResultNumber(result);
    } else {
      resultText = this.i18n.wrongDigits;
    }

    this.displayResult(resultText);
  }

  calculateBudget() {
    const formData = this.formData();

    const income = parseFloat(formData['budget-income'].replace(/,/g, ''));
    const debts = parseFloat(formData['budget-debts'].replace(/,/g, ''));
    const term = parseFloat(formData['budget-term']);

    const m = (income * 0.34) / 12 - term * 12 - debts;

    const formula = m * (term * 12);

    const result = Math.abs(Math.ceil(formula));
    let resultText = '';

    if (!Number.isNaN(result)) {
      resultText = LoanCalculator.formatResultNumber(result);
    } else {
      resultText = this.i18n.wrongDigits;
    }

    this.displayResult(resultText);
  }

  calculateRefinance() {
    const formData = this.formData();

    const loan = parseFloat(formData['refinance-loan'].replace(/,/g, ''));
    const rate = parseFloat(formData['refinance-rate']) / 100;
    const term = parseFloat(formData['refinance-loan-term']);
    const newLoan = parseFloat(
      formData['refinance-new-loan'].replace(/,/g, ''),
    );
    const newRate = parseFloat(formData['refinance-new-rate']) / 100;
    const newTerm = parseFloat(formData['refinance-new-loan-term']);

    const mp1 = (1 + rate / 12) ** (term * 12);
    const mp2 = (1 + newRate / 12) ** (term * 12);
    const mp3 = (1 + newRate / 12) ** (newTerm * 12);

    const currentPayment = (loan * ((rate / 12) * mp1)) / (mp1 - 1);
    const newPayment = (newLoan * ((newRate / 12) * mp2)) / (mp3 - 1);

    const formula = currentPayment - newPayment;

    const result = Math.ceil(formula);
    let resultText = '';

    if (!Number.isNaN(result)) {
      resultText = LoanCalculator.formatResultNumber(result);
    } else {
      resultText = this.i18n.wrongDigits;
    }

    this.displayResult(resultText);
  }
}

export default new LoanCalculator();
